export default [
  {
    content: "송풍기 또는 배풍기에 풍량 및 정압 등이 표시된 명판(name plate)이 설치되어있는가?",
    isChecked: "",
  },
  {
    content: "송풍기 또는 배풍기 하부 방진가대·고무·스프링의 설치 상태가 양호하며, 정상 기능을 수행하도록 유지 관리하고 있는가?",
    isChecked: "",
  },
  {
    content: "정상 가동 중 설비에서 이상음 또는 진동 발생이 없으며 전반적인 작동상태가 양호한가?",
    isChecked: "",
  },
  {
    content: "제어반(Control panel)은 정상 작동하고 있으며 , 금속 외함에 접지하였는가?",
    isChecked: "",
  },
  {
    content: "송풍기 또는 배풍기, 순환펌프의 회전부에 덮개를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "환경처리실비의 승강 계단과 점검용 발판 측면에 안전난간대를 설치하였는가",
    isChecked: "",
  },
  {
    content: "배출시설 자가 측정을 주기적으로 실시하여 처리설비에서 배출되는 오염물질 농도가 적정 수준인지 확인하고 있는가?",
    isChecked: "",
  },
  {
    content: "스크러버 순환펌프는 정상 작동하고 있으며, 펌프 및 순환배관에 파손 또는 누설이 없는가?",
    isChecked: "",
  },
  {
    content: "흡착탑의 활성탄 필터를 주기적으로 교체하며, 가급적 재생 필터 사용을 지양하는가?",
    isChecked: "",
  },
  {
    content: "흡착탑의 활성탄 필터 충진 공간의 차압을 정기적으로 확인하여 차압이 허용치에 도달하면 즉시 필터를 교환하는가?",
    isChecked: "",
  },
  {
    content: "흡착탑에서 필터의 배출가스 흡착열로 인한 활성탄 발화 위험을 알고 있으며, 온도계를 설치하여 흡착탑 내부 온도를 확인하는가?",
    isChecked: "",
  },
  {
    content: "연소·소각 설비의 버너 연료가스 누설을 감지하기 위한 가스 누출감지기를 설치하였는가?",
    isChecked: "",
  },
  {
    content: "연소·소각 설비의 버너 연료 공급 배관에 긴급 차단용 자동밸브(솔레노이드 밸브 등)가 설치되어 있는가?",
    isChecked: "",
  },
  {
    content: "초기 가동 중 버너 점화 실패 시 내부 자동 환기 여부를 반드시 확인하고, 반복적으로 점화를 시도하지는 않는가?",
    isChecked: "",
  },
  {
    content: "연소 소각설비의 스택(굴뚝)은 고온의 연소가스가 다른 위험을 유발하지 않는 장소에 설치되어 있는가?",
    isChecked: "",
  },
];
